// extracted by mini-css-extract-plugin
module.exports = {"content":"prompter_content__7BfZv TextLockup_content__gliM2 global_subgrid__ZRhT6","titles":"prompter_titles__urQ4n"};